<!-- =========================================================================================
  File Name: CustomerDashboard.vue
  Description: Account Summary
  ----------------------------------------------------------------------------------------
  Author: Faruk Nikmorad
  Auth Date: 22062020
========================================================================================== -->

<template>
  <!-- <vx-card> -->
      <vx-card noBackground noShadow noPadding>
        <div id="page-user-edit">
          <tab-user-account-dashboard :cardData="user_dashboardData" :dashboardItemsData="customerDashboardItems"/>
        </div>
      </vx-card>
  <!-- </vx-card> -->
</template>

<script>
import TabUserAccountDashboard     from '@/views/components/customer-tab/Tab_User_AccountDashboard.vue'

// Store Module
import moduleMt4Management from '@/store/mt4-management/moduleMt4Management.js'
import moduleMt4ReportManagement from '@/store/mt4report-management/moduleMt4ReportManagement.js'
import moduleTransactionManagement from '@/store/transaction-mng/moduleTransactionMng.js'

export default {
  components: {
    TabUserAccountDashboard
  },
  data () {
    return {
      user_accounts: null,
      loginList: [],
      customerDashboardItems: [],
      user_account_history: null,
      user_dashboardData: [],
      user_dashboard: {
        BALANCE: 0, 
        CREDIT: 0,
        EQUITY: 0,
        MARGIN: 0, 
        MARGIN_LEVEL: 0,
        MARGIN_FREE: 0,
        DEPOSITS : 0,
        WITHDRAWALS : 0
      },
      payload: {email: null, server: 'Real'}
    }
  },
  methods: {
    fetch_user_dashboard (userName, server) {
      this.payload.email =  userName
      this.payload.server =  server
      this.$store.dispatch('TransactionMng/fetchUserAccountsByEmail', this.payload)
        .then(res => { 
          this.user_accounts = res.data.data

          console.error(res.data.data)

          this.user_dashboard.Balance = 0
          this.user_dashboard.Credit = 0
          this.user_dashboard.Equity = 0
          this.user_dashboard.Margin = 0
          this.user_dashboard.Margin_Level = 0
          this.user_dashboard.Margin_Free = 0
          this.user_dashboard.DEPOSITS = 0
          this.user_dashboard.WITHDRAWALS = 0

          this.user_account_history = []
          this.loginList = []
          if (this.user_accounts && this.user_accounts.length > 0) {
            this.user_accounts.forEach(item => {

              this.user_dashboard.Balance += item.Balance
              this.user_dashboard.Credit += item.Credit
              this.user_dashboard.Equity += item.Equity
              this.user_dashboard.Margin += item.Margin
              this.user_dashboard.Margin_Level += item.Margin_Level
              this.user_dashboard.Margin_Free += item.Margin_Free

              this.loginList.push(item.Login)
              //this.fetch_ClientHistory(item.Login, '2010-01-01', '2020-10-01', 'Real')
            })
            //this.fetch_CustomerDashboardItems()
            
          }
          
          this.$store.dispatch('TransactionMng/fetchGetDepositWithdrawalAsync', this.loginList)
            .then(res => { 
              this.user_dashboard.DEPOSITS = res.deposit
              this.user_dashboard.WITHDRAWALS = res.withdrawal

              this.user_dashboardData.push({title: 'BALANCE',   value: this.$options.filters.moneyFormat(this.user_dashboard.Balance, 2, '$'),   icon: 'DollarSignIcon',        color: 'primary'})
              this.user_dashboardData.push({title: 'CREDIT',    value: this.$options.filters.moneyFormat(this.user_dashboard.Credit, 2, '$'),    icon: 'CreditCardIcon',     color: 'danger'})
              this.user_dashboardData.push({title: 'EQUITY',    value: this.$options.filters.moneyFormat(this.user_dashboard.Equity, 2, '$'),    icon: 'ActivityIcon',   color: 'primary'})
              this.user_dashboardData.push({title: 'MARGIN',    value: this.$options.filters.moneyFormat(this.user_dashboard.Margin, 2, '$'),    icon: 'RefreshCcwIcon',   color: 'primary'})
              this.user_dashboardData.push({title: 'MARGIN_LEVEL',    value: this.$options.filters.moneyFormat(this.user_dashboard.Margin_Level, 2, '%'),    icon: 'PercentIcon',   color: 'danger'})
              this.user_dashboardData.push({title: 'MARGIN_FREE',    value: this.$options.filters.moneyFormat(this.user_dashboard.Margin_Free, 2, '$'),    icon: 'AwardIcon',   color: 'primary'})
              this.user_dashboardData.push({title: 'DEPOSITS',    value: this.$options.filters.moneyFormat(this.user_dashboard.DEPOSITS, 2, '$'),    icon: 'DollarSignIcon',   color: 'warning'})
              this.user_dashboardData.push({title: 'WITHDRAWALS',    value: this.$options.filters.moneyFormat(this.user_dashboard.WITHDRAWALS, 2, '$'),    icon: 'DollarSignIcon',   color: 'success'})

              this.$vs.loading.close('#page-user-edit > .con-vs-loading')

            })

        })
        .catch(err => {
          console.error(err)
        })
    },
    fetch_ClientHistory (client, start, end, server) {
      this.payload.client =  client
      this.payload.start =  start
      this.payload.end =  end
      this.payload.server =  server

      this.$store.dispatch('Mt4Management/fetchClientHistory', this.payload)
        .then(res => { 
          if (this.user_account_history) this.user_account_history = this.user_account_history.concat(res.data)
          else this.user_account_history = res.data

        })
        // .catch(err => {
        //   if (err.response.status === 404) {
          
        //   }
        // })
    },
    fetch_CustomerDashboardItems () {
      this.customerDashboardItems = []
      this.$store.dispatch('Mt4ReportManagement/fetchCustomerDashboardItems', this.loginList)
        .then(res => { 
          this.customerDashboardItems = res.data
        })
    }
    
  },
  mounted () {
    this.$vs.loading({
      container: '#page-user-edit',
      type: 'sound',
      scale: 1
    })
    this.fetch_user_dashboard(this.$store.state.AppActiveUser.email, 'Real')

  },

  // beforeRouteEnter(to, from, next) {
  //   const mgr = new Mgr()
  //   mgr.getUser().then(async user  => {
  //     if (vm.$store.state.AppActiveUser.customerId === -1) {
  //       vm.$store.dispatch('fetchCustomerByUserName', user.profile.email).then(customerInfo => {
  //         if (customerInfo !== null) {
  //           vm.$store.dispatch('updateUserInfo', {displayName : `${customerInfo.data.firstName} ${customerInfo.data.lastName}`, email : user.profile.email, customerId : customerInfo.data.id})
  //           next()
  //         }
  //       })
  //     }
  //     else {
  //       next()
  //     }
  //   })
  // },
  created () {
    if (!moduleMt4Management.isRegistered) {
      this.$store.registerModule('Mt4Management', moduleMt4Management)
      moduleMt4Management.isRegistered = true
    }
    if (!moduleMt4ReportManagement.isRegistered) {
      this.$store.registerModule('Mt4ReportManagement', moduleMt4ReportManagement)
      moduleMt4ReportManagement.isRegistered = true
    }
    if (!moduleTransactionManagement.isRegistered) {
      this.$store.registerModule('TransactionMng', moduleTransactionManagement)
      moduleTransactionManagement.isRegistered = true
    }      
  }
}

</script>
